<mat-toolbar color="accent" fxLayout="row">
  <div fxFlex="5">
    <button *ngIf="isPaymentSupported()"
            type="button"
            mat-fab color="primary"
            matTooltip="Add Payment"
            (click)="addPaymentStrategy();">+P
    </button>
  </div>
  <div fxFlex="1 1 auto" fxLayoutAlign="center center" >
    <h1 mat-dialog-title>Payments</h1>
  </div>
</mat-toolbar>
<div mat-dialog-content>
  <div *ngFor="let payment of payments|async| keyvalue">
    <mat-card>
      <mortgage-payment [payment]="payment.value" [mortgageId]="mortgageId"
                        [scenarioId]="scenarioId"></mortgage-payment>
    </mat-card>
  </div>
</div>

